// useNextTick.js
import { useCallback, useEffect, useRef, useState } from 'react';

const useNextTick = () => {
  const [tick, setTick] = useState(0);
  const callbackRef = useRef(null);

  const nextTick = useCallback((callback) => {
    callbackRef.current = callback;
    setTick(tick => tick + 1); // 触发一次更新
    // 触发一次更新，以便在下一个渲染周期执行
  }, []);

  // 在组件更新后执行回调
  useEffect(() => {
    if (callbackRef.current) {
      callbackRef.current(); // 执行回调
      callbackRef.current = null; // 清空回调
    }
  }, [tick]);

  return nextTick;
};

// 导出
export { useNextTick };
